import React from "react"
import { Router } from "@reach/router"

import Seo from "../components/seo"
import Layout from "../components/layout"
import Secure from "../components/businessSupport/Secure"

import GetStarted from "../components/businessSupport/getStarted"
import TinCorrection from "../components/businessSupport/tinCorrection"
import TinApplication from "../components/businessSupport/tinApplication"
import BusinessRegistration from "../components/businessSupport/businessRegistration"
import CompanyRegistration from "../components/businessSupport/companyRegistration"
import Verify from "../components/businessSupport/Verify"
import Nav from "../components/nav"
import StartTinUpdate from "../components/businessSupport/startTinUpdate/"
import StartTinApplication from "../components/businessSupport/startTinApplication"
import StartBusinessRegistration from "../components/businessSupport/startBusinessRegistration"
import StartCompanyRegistration from "../components/businessSupport/startCompanyRegistration"

import "../style/business-support.css"
import BusinessReg from "../components/businessSupport/MobileFlow/BusinessReg"
import MobileNewTin from "../components/businessSupport/MobileNewTin"
import MobileCompanyReg from "../components/businessSupport/mobileCompanyRegistration"
import MobileSecure from "../components/businessSupport/MobileSecure"

const App = () => {
  return (
    <Layout downloadFooter="false">
      <Seo
        title="Business support and value added services from Sparkle"
        desc="Sparkle offers business support solutions as part of our value added services, helping business owners efficiently get their CAC, TIN and other business certifications"
      />
      <div style={{ background: "#F8F8F8" }}>
        <div className="nav-wrapper bg__sparkle--black mb-5">
          <div className="container">
            <Nav />
          </div>
        </div>
        <div className="container mt-5 pt-5 pb-5">
          <Router>
            <GetStarted exact path="/business-support/" />
            <GetStarted exact path="/business-support/get-started" />
            <TinCorrection exact path="/business-support/tin-correction" />
            <TinApplication exact path="/business-support/tin-application" />

            <CompanyRegistration
              exact
              path="/business-support/company-incorporation"
            />
            <BusinessRegistration
              exact
              path="/business-support/business-registration"
            />

            <Verify exact path="/business-support/verify" />

            <MobileSecure
              exact
              path="/business-support/mobile-business-reg/start"
              component={BusinessReg}
            />
            <MobileSecure
              exact
              path="/business-support/mobile-tin-reg/start"
              component={MobileNewTin}
            />
            <MobileSecure
              exact
              path="/business-support/mobile-company-reg/start"
              component={MobileCompanyReg}
            />

            <Secure
              exact
              path="/business-support/tin-correction/start"
              component={StartTinUpdate}
            />

            <Secure
              exact
              path="/business-support/tin-application/start"
              component={StartTinApplication}
            />

            <Secure
              exact
              path="/business-support/business-registration/start"
              component={StartBusinessRegistration}
            />

            <Secure
              exact
              path="/business-support/company-incorporation/start"
              component={StartCompanyRegistration}
            />
          </Router>
        </div>
      </div>
    </Layout>
  )
}

export default App
